<div fxLayout="column" fxLayoutAlign="center center">
    <h1 class="mat-headline">{{'unauthorized'| translate}}</h1>
    {{'unauthorized-description' | translate}}
</div>
